import capitalize from 'underscore.string/capitalize';

angular.module('filters').filter('capitalize', function() {
  return function(data) {
    return capitalize(data);
  };
});
